<template>
    <div class="d-inline align-middle w-100">
        <span class="text-uppercase text-center align-middle d-block bg-danger text-white p-1">
            Des licences comportent des erreurs :
            <u><router-link class="text-white" :to="{ name: 'subscription' }">Vérifier mes licences </router-link></u>
        </span>
    </div>
</template>
